import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { addCommentByBlog } from "@store/action/smartend/CommentAction";
import { useSelector } from "react-redux";
import { useRouteMatch, useParams } from "react-router-dom";
import GoogleAuth from "@src/auth/socialAuth";

const CommentForm = ({ t, dispatch }) => {
  const { id } = useParams();
  const [comment, setComment] = useState("");
  const CommentReducer = useSelector((state) => state.CommentReducer);
  const authReducer = useSelector((state) => state.auth.social_user);
  const myURL = "/" + useRouteMatch().params.webmasterTitle;
  const emptyField = () => {
    setComment("");
  };
  const handleAddComment = () => {
    const datas = {
      topic_id: id,
      name: `${authReducer.first_name} ${authReducer.last_name}`,
      email: authReducer.email,
      user_id: 1,
      comment,
      avatar: authReducer.avatar,
    };
    dispatch(addCommentByBlog(myURL, datas, id, emptyField));
  };
  return (
    <div className="comments_Box">
      {authReducer !== null ? (
        <div className="text_wrapper">
          <div className="contect_form_footer">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <img
                    style={{
                      height: "100px",
                      width: "100px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                    src={authReducer?.avatar}
                  />
                </div>
              </div>
            </div>
            <Row>
              <Col sm="12 mb-1" md="6">
                <input
                  type="text"
                  placeholder={t("Your Name")}
                  id="name"
                  disabled
                  value={`${authReducer?.first_name} ${authReducer?.last_name}`}
                />
                <p
                  style={{
                    width: "100%",
                    fontSize: "0.857rem",
                    color: "#ea5455",
                  }}
                >
                  <span style={{ opacity: "0" }}>.</span>
                  {CommentReducer.error &&
                    CommentReducer.error.name &&
                    CommentReducer.error.name}
                </p>
              </Col>
              <Col sm="12 mb-1" md="6">
                <input
                  type="email"
                  placeholder={t("Your Email")}
                  id="email"
                  value={authReducer?.email}
                  disabled
                />
                <p
                  style={{
                    width: "100%",
                    fontSize: "0.857rem",
                    color: "#ea5455",
                  }}
                >
                  <span style={{ opacity: "0" }}>.</span>
                  {CommentReducer.error &&
                    CommentReducer.error.email &&
                    CommentReducer.error.email}
                </p>
              </Col>
            </Row>
            <textarea
              placeholder={t("Your Comment")}
              id="comment"
              onChange={(e) => setComment(e.target.value)}
              value={comment}
            />
            {CommentReducer.error && CommentReducer.error.comment && (
              <p
                style={{
                  width: "100%",
                  fontSize: "0.857rem",
                  color: "#ea5455",
                }}
              >
                {CommentReducer.error.comment}
              </p>
            )}
          </div>
          <div className="lang_apply_btn comment_btn">
            <ul>
              <li>
                <a
                  onClick={() => {
                    handleAddComment();
                  }}
                >
                  <i className="flaticon-play-button" />
                  {t("Post Comment")}
                </a>
              </li>
            </ul>
          </div>
        </div>
      ) : (
        <GoogleAuth />
      )}
    </div>
  );
};

export default CommentForm;
